module.exports = __webpack_public_path__ + "img/noun_History_3323396 1.47f0e9e8.svg";